/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Simple_Successunsubscribe1Inputs */

const id_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhasil berhenti berlangganan notifikasi`)
};

const ms_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berjaya berhenti melanggan pemberitahuan`)
};

const da_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afmelding af notifikationer lykkedes`)
};

const de_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen erfolgreich abgemeldet`)
};

const en_us2_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successfully unsubscribed from notifications`)
};

const es_es2_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desuscrito correctamente de las notificaciones`)
};

const es_mx2_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripción a notificaciones cancelada exitosamente`)
};

const fil_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matagumpay na nag-unsubscribe mula sa mga notipikasyon`)
};

const fr_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désabonnement des notifications réussi`)
};

const it_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annullamento iscrizione alle notifiche riuscito`)
};

const hu_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sikeresen leiratkoztál az értesítésekről`)
};

const nl_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succesvol uitgeschreven van meldingen`)
};

const no_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vellykket avmelding fra varsler`)
};

const pl_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomyślnie wypisano z powiadomień`)
};

const pt_br2_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successfully unsubscribed from notifications`)
};

const pt_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscrição de notificações cancelada com sucesso`)
};

const ro_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te-ai dezabonat cu succes de la notificări`)
};

const fi_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoitusten tilaus peruutettu onnistuneesti`)
};

const sv_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notisprenumeration avslutad`)
};

const vi_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã hủy đăng ký thông báo thành công`)
};

const tr_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirim aboneliği başarıyla iptal edildi`)
};

const cs_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úspěšně odhlášeno od oznámení`)
};

const bg_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Успешно отписване от известия`)
};

const ru_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Успешно отписались от уведомлений`)
};

const uk_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Успішно відписано від сповіщень`)
};

const ar_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم إلغاء الاشتراك من الإشعارات بنجاح`)
};

const hi_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सफलतापूर्वक सूचनाओं से सब्सक्रिप्शन रद्द किया`)
};

const th_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยกเลิกการสมัครรับการแจ้งเตือนสำเร็จ`)
};

const ja_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知の購読解除に成功しました`)
};

const zh_cn2_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successfully unsubscribed from notifications`)
};

const zh_hant1_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successfully unsubscribed from notifications`)
};

const ko_notifications_simple_successunsubscribe1 = /** @type {(inputs: Notifications_Simple_Successunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successfully unsubscribed from notifications`)
};

/**
* | output |
* | --- |
* | "Successfully unsubscribed from notifications" |
*
* @param {Notifications_Simple_Successunsubscribe1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_successunsubscribe1 = /** @type {((inputs?: Notifications_Simple_Successunsubscribe1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Successunsubscribe1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_successunsubscribe1(inputs)
	if (locale === "ms") return ms_notifications_simple_successunsubscribe1(inputs)
	if (locale === "da") return da_notifications_simple_successunsubscribe1(inputs)
	if (locale === "de") return de_notifications_simple_successunsubscribe1(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_successunsubscribe1(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_successunsubscribe1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_successunsubscribe1(inputs)
	if (locale === "fil") return fil_notifications_simple_successunsubscribe1(inputs)
	if (locale === "fr") return fr_notifications_simple_successunsubscribe1(inputs)
	if (locale === "it") return it_notifications_simple_successunsubscribe1(inputs)
	if (locale === "hu") return hu_notifications_simple_successunsubscribe1(inputs)
	if (locale === "nl") return nl_notifications_simple_successunsubscribe1(inputs)
	if (locale === "no") return no_notifications_simple_successunsubscribe1(inputs)
	if (locale === "pl") return pl_notifications_simple_successunsubscribe1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_successunsubscribe1(inputs)
	if (locale === "pt") return pt_notifications_simple_successunsubscribe1(inputs)
	if (locale === "ro") return ro_notifications_simple_successunsubscribe1(inputs)
	if (locale === "fi") return fi_notifications_simple_successunsubscribe1(inputs)
	if (locale === "sv") return sv_notifications_simple_successunsubscribe1(inputs)
	if (locale === "vi") return vi_notifications_simple_successunsubscribe1(inputs)
	if (locale === "tr") return tr_notifications_simple_successunsubscribe1(inputs)
	if (locale === "cs") return cs_notifications_simple_successunsubscribe1(inputs)
	if (locale === "bg") return bg_notifications_simple_successunsubscribe1(inputs)
	if (locale === "ru") return ru_notifications_simple_successunsubscribe1(inputs)
	if (locale === "uk") return uk_notifications_simple_successunsubscribe1(inputs)
	if (locale === "ar") return ar_notifications_simple_successunsubscribe1(inputs)
	if (locale === "hi") return hi_notifications_simple_successunsubscribe1(inputs)
	if (locale === "th") return th_notifications_simple_successunsubscribe1(inputs)
	if (locale === "ja") return ja_notifications_simple_successunsubscribe1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_successunsubscribe1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_successunsubscribe1(inputs)
	return ko_notifications_simple_successunsubscribe1(inputs)
});
export { notifications_simple_successunsubscribe1 as "notifications.simple.successUnsubscribe" }